import { GET } from "./";
export const typeDocument = {
  getActives: (countryId) => GET(`/api/typeDocument/${countryId}/actives`),
};
